// extracted by mini-css-extract-plugin
module.exports = {"root":"searchbox_root__p85be"};